import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './FarmType.css';
import { HiArrowLongLeft } from "react-icons/hi2";
import { useNavigate } from 'react-router-dom';
import logo_agroinsider_color from '../../assets/logo-agroinsider-color.svg';
import img_farm_profile from '../../assets/perfil_da_herdade_inicio.svg';
import logo_footer_color from '../../assets/logos_footer_color.svg';
import animal_production_icon from '../../assets/producao_animal.svg';
import culture_production_icon from '../../assets/producao_agricola.svg';
import florest_production_icon from '../../assets/producao_florestal.svg';
import culture_soil_icon from '../../assets/culturas_agricolas.svg';
import olive_soil_icon from '../../assets/montado.svg';
import LanguageSwitcher from '../../components/LanguageSwitcher/LanguageSwitcher';

const FarmType = ({ farmType, setFarmType }) => {
  const [formData, setFormData] = useState(farmType);
  const { t } = useTranslation();
  const navigate = useNavigate(); // Para navegação programática

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleNavigateBack = () => {
    navigate('/general-information');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFarmType(formData);
    if (formData.producaoAgricola) {
      navigate('/vegetal-production');
    } else if (formData.producaoAnimal) {
      navigate('/animal-production');
    } else {
      navigate('/fuel-spent');
    }
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    if (name === 'producaoFlorestal' || name === 'producaoAgricola' || name === 'producaoAnimal') {
      const checkboxs = document.getElementById(name);
      if (checkboxs) {
        if (checked) {
          checkboxs.classList.replace('nested-checkboxes-hidden', 'nested-checkboxes-visible');
        } else {
          checkboxs.classList.replace('nested-checkboxes-visible', 'nested-checkboxes-hidden');
        }
      }
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: checked,
    }));
  };

  const handleNestedCheckboxChange = (e) => {
    const { name, checked } = e.target;

    if (name === 'montado' || name === 'eucaliptal' || name === 'pinhal' || name === 'outros') {
      const checkboxs = document.getElementById(name);
      if (checkboxs) {
        if (checked) {
          checkboxs.classList.replace('nested-checkboxes-hidden', 'nested-checkboxes-visible');
        } else {
          checkboxs.classList.replace('nested-checkboxes-visible', 'nested-checkboxes-hidden');
        }
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      detalhesProducaoFlorestal: {
        ...prevData.detalhesProducaoFlorestal,
        [name]: checked,
      },
    }));
  };

  const handleNestedInputChange = (event) => {
    const { name, value } = event.target;
    if (value && value.length > 0) {
      const numericValue = Math.max(0, Number(value)); // Garante que o valor seja >= 0

      if (numericValue) {
        setFormData((prevState) => ({
          ...prevState,
          amount: {
            ...prevState.amount,
            [name]: numericValue,
          },
        }));
      }
    } else {
      setFormData((prevState) => ({
        ...prevState,
        amount: {
          ...prevState.amount,
          [name]: 0,
        },
      }));
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className='form-background'>
        <div className='div-agroinsider-logo'>
          <img src={logo_agroinsider_color} alt="AgroInsider Logo" className="logo" />
        </div>
        <div className='div-page-logo'>
          <img className='img-page-logo' src={img_farm_profile} alt="AgroInsider Logo" />
        </div>
        <div className='farm-profile-description'>
          <span className='farm-profile-title'>{t('FarmProfile.title')}</span>
          <p className='farm-profile-description-text'>{t('FarmType.description')}</p>
        </div>
        <div className="form-profile-form">
          <div className="form-group">
            <label className='form-input-title' htmlFor="farmName">{t('FarmType.spicesTitle')}</label>
            <div className="nested-checkboxes">
              <div>
                <div className='grid-container-checkbox'>
                  <div className='grid-item'>
                    <img alt='icon' src={animal_production_icon} className="icon" />
                  </div>
                  <div className='grid-item'>
                    <span className='input-font-style'>{t("FarmType.checkboxOption1")}</span>
                  </div>
                  <div className='grid-item' style={{ justifyContent: "center" }}>
                    <input
                      type="checkbox"
                      name="producaoAnimal"
                      checked={formData.producaoAnimal}
                      onChange={handleCheckboxChange}
                    />
                  </div>
                </div>
                <div className='grid-container-checkbox'>
                  <div className='grid-item'>
                    <img alt='icon' src={culture_production_icon} className="icon" />
                  </div>
                  <div className='grid-item'>
                    <span className='input-font-style'>{t("FarmType.checkboxOption2")}</span>
                  </div>
                  <div className='grid-item' style={{ justifyContent: "center" }}>
                    <input
                      type="checkbox"
                      name="producaoAgricola"
                      checked={formData.producaoAgricola}
                      onChange={handleCheckboxChange}
                    />
                  </div>
                </div>

                <div className='grid-container-checkbox'>
                  <div className='grid-item'>
                    <img alt='icon' src={florest_production_icon} className="icon" />
                  </div>
                  <div className='grid-item'>
                    <span className='input-font-style'>{t("FarmType.checkboxOption3")}</span>
                  </div>
                  <div className='grid-item' style={{ justifyContent: "center" }}>
                    <input
                      type="checkbox"
                      name="producaoFlorestal"
                      checked={formData.producaoFlorestal}
                      onChange={handleCheckboxChange}
                    />
                  </div>
                </div>
              </div>

              <div id='producaoFlorestal' className="nested-checkboxes nested-checkboxes-hidden">
                <label>
                  <input
                    type="checkbox"
                    name="montado"
                    checked={formData.detalhesProducaoFlorestal.montado}
                    onChange={handleNestedCheckboxChange}
                  />
                  Montado
                </label>
                <div id='montado' className="nested-checkboxes nested-checkboxes-hidden" style={{ marginLeft: "75px" }}>
                  <label style={{ gap: "10px" }}>
                    {t('VegetalProduction.cultivated_area')}
                    <input
                      type="text"
                      name="montado_amount"
                      placeholder={t('VegetalProduction.hectare_placeholder')}
                      onChange={(e) => handleNestedInputChange(e)}
                      min={0}
                      value={formData.detalhesProducaoFlorestal.montadoAmount}
                    />
                  </label>
                </div>
                <label>
                  <input
                    type="checkbox"
                    name="eucaliptal"
                    checked={formData.detalhesProducaoFlorestal.eucaliptal}
                    onChange={handleNestedCheckboxChange}
                  />
                  Eucaliptal
                </label>
                <div id='eucaliptal' className="nested-checkboxes nested-checkboxes-hidden" style={{ marginLeft: "75px" }}>
                  <label style={{ gap: "10px" }}>
                    {t('VegetalProduction.cultivated_area')}
                    <input
                      type="text"
                      name="eucaliptal_amount"
                      placeholder={t('VegetalProduction.hectare_placeholder')}
                      onChange={(e) => handleNestedInputChange(e)}
                      min={0}
                      value={formData.detalhesProducaoFlorestal.eucaliptalAmount}
                    />
                  </label>
                </div>
                <label>
                  <input
                    type="checkbox"
                    name="pinhal"
                    checked={formData.detalhesProducaoFlorestal.pinhal}
                    onChange={handleNestedCheckboxChange}
                  />
                  Pinhal
                </label>
                <div id='pinhal' className="nested-checkboxes nested-checkboxes-hidden" style={{ marginLeft: "75px" }}>
                  <label style={{ gap: "10px" }}>
                    {t('VegetalProduction.cultivated_area')}
                    <input
                      type="text"
                      name="pinhal_amount"
                      placeholder={t('VegetalProduction.hectare_placeholder')}
                      onChange={(e) => handleNestedInputChange(e)}
                      min={0}
                      value={formData.detalhesProducaoFlorestal.pinhalAmount}
                    />
                  </label>
                </div>
                <label>
                  <input
                    type="checkbox"
                    name="outros"
                    checked={formData.detalhesProducaoFlorestal.outros}
                    onChange={handleNestedCheckboxChange}
                  />
                  Outros
                </label>
              </div>
            </div>
          </div>

          <div className="form-group">
            <label className='form-input-title' htmlFor="farmName">{t('FarmType.soilMobility')}</label>
            <div className="nested-checkboxes">
              <div className='grid-container-checkbox'>
                <div className='grid-item'>
                  <img alt='icon' src={culture_soil_icon} className="icon" />
                </div>
                <div className='grid-item'>
                  <span className='input-font-style'>Nas culturas agrícolas</span>
                </div>
                <div className='grid-item'>
                  <input
                    type="checkbox"
                    name="mobilizacaoAgricola"
                    checked={formData.mobilizacaoAgricola}
                    onChange={handleCheckboxChange}
                  />
                </div>
              </div>
              <div className='grid-container-checkbox'>
                <div className='grid-item'>
                  <img alt='icon' src={olive_soil_icon} className="icon" />
                </div>
                <div className='grid-item' style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                  <span className='input-font-style'>No montado</span> <span className='input-font-style' style={{ fontSize: "16px" }}>(desmatação com mobilização do solo)</span>
                </div>
                <div className='grid-item'>
                  <input
                    type="checkbox"
                    name="mobilizacaoMontado"
                    checked={formData.mobilizacaoMontado}
                    onChange={handleCheckboxChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='form-group-bottom-buttons'>
          <div className="form-group-buttons">
            <button className='form-back-button' onClick={() => handleNavigateBack()}>
              <HiArrowLongLeft size={28} />
            </button>
            <button className="form-next-button" type="submit">{t('AnimalProduction.submit')}</button>
          </div>
        </div>
        <LanguageSwitcher />
        <div className='div-logo-footer-color'>
          <img src={logo_footer_color} alt="AgroInsider Logo" className="logo" />
        </div>
      </div>
    </form>
  );
}

export default FarmType;
